import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ModalStates} from '../../globals/Constants';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';

export default class AddReviewersButton extends React.Component<AddReviewersButtonProps, {}> {
   constructor(props: AddReviewersButtonProps) {
      super(props);
      autoBind(this);
   }

   clickAddReviewers(): void {
      this.props.setModalState(ModalStates.manageReviewers);
   }

   render() {
      const {themeName} = this.props;
      return (
         <div className="add-reviewer-button-wrapper">
            <ControlButton buttonType={TscButtonType.secondary}
                           themeName={themeName}
                           title={Strings.labels.addReviewersButtonTitle}
                           label={Strings.labels.addReviewersButtonText}
                           onClick={this.clickAddReviewers}
                           testId="add-reviewer-button" />
         </div>
      );
   }
}

export interface AddReviewersButtonProps extends Themeable {
   setModalState(modalState: ModalStates): void;
}
